import Button from '@/shared/Button/Button';
import Link from 'next/link';
import { StyledPremiumContentWarning } from './PremiumContentWarning.styled';
import { Alert } from 'antd';

export default function PremiumContentWarning({ isStudent }) {
  return (
    <StyledPremiumContentWarning>
      {isStudent ? (
        <p>
          This content is not available. <br />
          Please, talk to your teacher
        </p>
      ) : (
        <div className="text">
          You need a <strong>subscription</strong> to see this.
          <br />
          <Link href="/sign-up" passHref>
            <Button type="important" size="small" className="sign-up-button">
              Sign up
            </Button>
          </Link>
          {' or '}
          <Link href="/login" passHref>
            <Button type="primary" size="small" className="log-in-button">
              Log in
            </Button>
          </Link>{' '}
          to access the full content.
          <br />
          Subscriptions start at just <strong>$20</strong>.
          <br />
          See more about this activity{' '}
          <span
            className="link"
            onClick={() => {
              const element = document.getElementById('public-description');
              if (element) {
                element.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                });
              }
            }}
          >
            here.
          </span>
        </div>
      )}
    </StyledPremiumContentWarning>
  );
}
